/* eslint-disable no-lonely-if */
import React from 'react';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonPest } from '../../../../utils/Button';
import { handleLogoutAllOpe } from '../AuthManageOperation';
import { useAuthManage } from '../AuthManageProvider';

function PageHeaderRightCol() {
    const { handleReload } = useAuthManage();
    const { setMessage, setConfirm } = useTemplate();

    const handleLogoutAllClick = (e) => {
        e.stopPropagation();

        setConfirm({
            text: 'Are you sure you want to log out all users? This action will terminate all active sessions?',
            textAction: 'Yes',
            clickAction: () => {
                handleLogoutAllOpe()
                    .then(({ title }) => {
                        setConfirm(null);
                        handleReload();
                        setMessage({ type: 'success', text: title });
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };

    return (
        <div className="customer_page_header_right_col flex-1 flex flex-row gap-2 justify-end items-center ">
            <ReloadButton
                onClick={handleReload}
                className="!w-[35px] !h-[35px] lg:!w-10 lg:!h-10 block"
            />

            <ButtonPest
                title="Logout All"
                onClick={handleLogoutAllClick}
                className="!h-[35px] lg:!h-10"
            />
        </div>
    );
}

function PageHeader() {
    return (
        <div className="w-full mb-3 md:mb-7 flex flex-row justify-end items-center">
            <PageHeaderRightCol />
        </div>
    );
}

export default PageHeader;
